import { isString, isNumber } from 'lodash';

export default function (value, defaultValue) {
    if (isNumber(value)) {
        return !!value;
    }

    if (isString(value)) {
        value = value.toLowerCase();

        if (value === 'false' || value === 'off') {
            return false;
        }

        if (value === 'true' || value === 'on') {
            return true;
        }
    }

    return defaultValue || false;
}
